document.addEventListener("DOMContentLoaded", function () {
    const productId = window.productId;
    if (!productId) return;

    const originalEl = document.getElementById("cart-original-price");
    const discountedEl = document.getElementById("cart-discounted-price");
    const savingsEl = document.getElementById("cart-savings");

    const saleBadge = document.getElementById("sale-badge");
    const soldoutBadge = document.getElementById("soldout-badge");

    // Hardcoded fallback prices
    const CORRECT_ORIGINAL = 6.99;
    const CORRECT_DISCOUNTED = 5.60;

    function updateBlock() {
        fetch("/cart.js")
            .then(res => res.json())
            .then(cart => {
                const item = cart.items.find(i => i.product_id === productId);
                let original, discounted, savings;

                if (item && item.original_price && item.final_price) {
                    original = item.original_price / 100;
                    discounted = item.final_price / 100;
                    savings = (item.original_price - item.final_price) / 100;
                } else {
                    original = CORRECT_ORIGINAL;
                    discounted = CORRECT_DISCOUNTED;
                    savings = (original - discounted);
                }

                // Update UI
                originalEl.textContent = `$${original.toFixed(2)}`;
                discountedEl.textContent = `$${discounted.toFixed(2)}`;
                savingsEl.textContent = `You are saving: $${savings.toFixed(2)}`;
                originalEl.style.textDecoration = "line-through";

                // --- ✨ Dynamic Sale Badge Logic ---
                if (discounted < original) {
                    saleBadge.style.display = "inline-flex";
                } else {
                    saleBadge.style.display = "none";
                }

                // --- ✨ Dynamic Sold Out Badge Logic (optional) ---
                if (item && item.quantity === 0) {
                    soldoutBadge.style.display = "inline-flex";
                } else {
                    soldoutBadge.style.display = "none";
                }
            })
            .catch(err => console.error("Error fetching cart:", err));
    }

    // Initial load
    updateBlock();

    // Update on variant change
    document.addEventListener("change", function (e) {
        if (e.target.name === "id") setTimeout(updateBlock, 100);
    });

    // Auto-watch Shopify price change on the product page
    const priceEl = document.querySelector(".price-item--sale") || document.querySelector(".price-item--regular");
    if (priceEl) {
        new MutationObserver(() => updateBlock()).observe(priceEl, { childList: true, subtree: true });
    }
});
